
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.967.295c-.926 0-1.676.73-1.676 1.632-.002 9.917-8.256 17.955-18.436 17.953-5.17 0-10.102-2.117-13.593-5.832l7.423-2.411c.88-.285 1.355-1.21 1.063-2.067-.293-.856-1.243-1.32-2.122-1.035L1.572 11.8a1.637 1.637 0 00-1.146 1.554v9.795c0 .901.75 1.632 1.676 1.632.925 0 1.675-.73 1.675-1.632v-5.963c8.627 8.136 22.392 7.919 30.744-.485 3.936-3.961 6.132-9.26 6.121-14.774 0-.901-.75-1.632-1.675-1.632z","fill":"#1B3067"}})])
          )
        }
      }
    